import {BankOption} from "@/store/shop/types";

export class Sale {
    saleId!: string;
    name!: string;
    startAt!: number;
    endAt!: number;
}

export class SaleDetails extends Sale {
    options!: SaleOption[];
}

export class SaleOption extends BankOption {
    oldPrice!: number;
    discountDesc!: string;
    countRemain!: number;
    countTotal!: number;
}
